import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';
import { API_URL } from '../config/api';

const ThemeContext = createContext();

export const useTheme = () => useContext(ThemeContext);

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadTheme();
  }, []);

  const loadTheme = async () => {
    try {
      setLoading(true);
      
      // Axios interceptor will automatically set X-Frontend-Host header
      const response = await axios.get(`${API_URL}/api/theme/public/frontend`);
      
      if (response.data.success) {
        const themeData = response.data.data;
        setTheme(themeData);
        applyTheme(themeData.theme);
      }
    } catch (error) {
      console.error('Error loading theme:', error);
      // Fallback to default theme (MODERN_ART)
      setTheme({ themeCode: 'MODERN_ART', theme: {}, themeName: 'Modern Art & Craft' });
    } finally {
      setLoading(false);
    }
  };

  const applyTheme = (themeConfig) => {
    if (!themeConfig) return;
    
    const root = document.documentElement;
    
    // Apply CSS variables for colors
    if (themeConfig.colors) {
      Object.entries(themeConfig.colors).forEach(([key, value]) => {
        root.style.setProperty(`--color-${key}`, value);
      });
      
      // Also apply background color to body
      if (themeConfig.colors.background) {
        document.body.style.backgroundColor = themeConfig.colors.background;
      }
    }
    
    // Apply CSS variables for fonts
    if (themeConfig.fonts) {
      Object.entries(themeConfig.fonts).forEach(([key, value]) => {
        root.style.setProperty(`--font-${key}`, value);
      });
      
      // Apply body font family
      if (themeConfig.fonts.body) {
        document.body.style.fontFamily = themeConfig.fonts.body;
      }
    }
    
    console.log('✅ Theme applied:', themeConfig);
  };

  const value = {
    theme,
    loading,
    reloadTheme: loadTheme
  };

  return (
    <ThemeContext.Provider value={value}>
      {children}
    </ThemeContext.Provider>
  );
};

